export class RegexGuru {
  public static int: RegExp = /^[-+]?[0-9]\d*$/;
  // public static decimal: RegExp = /\d+(\.\d{1,2})?/;
  // public static decimal: RegExp = /^(\d*\.)?\d+$/;
  // public static decimal: RegExp = /^[0-9]+(\.[0-9]{1,2})?$/;
  public static decimal: RegExp = new RegExp(/^-?[0-9]+(\.[0-9]*){0,1}$/g);
  public static alpha: RegExp = /^[A-Za-z]\d*$/;
  public static alphaNum: RegExp = /^[A-Za-z0-9]+$/i;
  public static alphaspcl: RegExp = /^[-+]?[1-9]\d*$/;
  public static alphaNumSpcl: RegExp = /^[a-zA-Z0-9 -.!”$%&’()*\+,\/;\[\\\]\^_`{|}~]+$/;
  public static alphaNumDot: RegExp = /^[A-Za-z. 0-9]+$/i;
  public static mobile: RegExp = /^[-+]?[0-9]\d*$/;
  public static email: RegExp = /^([a-zA-Z0-9_\-\.]+)@([a-zA-Z0-9_\-\.]+)\.([a-zA-Z]{2,5})$/;
  public static version: RegExp = /^[0-9.]$/;
  public static apiRoute: RegExp = /^[a-z\-./0-9\{\}]+$/;
  public static alphaSpaceDot: RegExp = /^[A-Za-z. ]\d*$/;

}



// WEBPACK FOOTER //
// E:/GangaJewallery-Final/app.server/systemic.app.server/client/src/main/@systemic/helper/regex.guru.ts